import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose, branch, lifecycle, renderComponent } from 'recompose';

import authHOC from '../Components/AuthHOC';
import Spinner from '../Components/Spinner';
import ModuleView from './Components/ModuleView';
import { withRouter } from 'react-router-dom';

import {
  saveVersionRequest,
  overwriteVersionRequest,
  resetSaveEditForm,
} from '../redux/reducers/savedVersions';

import {
  getClientBackGroundRequest,
  toggleSaveEditPopup,
  toggleRefererPage,
} from '../redux/reducers/view';
import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';

import {
  getUserProgramsFullRequest,
} from '../redux/reducers/userProgramsFull';



import { selectedContentItem, getAllThinkTools, getAllThinkToolsAndJournals } from '../redux/selectors';
import { connectedUsersRequest } from '../redux/reducers/connectedUsers';
import { modulesListRequest } from '../redux/reducers/modulesList';
import { dropdownsRequest } from '../redux/reducers/dropdowns';

const Modules = ({ view }) => <ModuleView view={view} />;

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  view: state.viewReducer,
  savedVersions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  getAllThinkToolsAndJournals: getAllThinkToolsAndJournals(state),
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getClientBackGroundRequest: () => dispatch(getClientBackGroundRequest()),
  toggleSaveEditPopup: value => dispatch(toggleSaveEditPopup(value)),
  toggleRefererPage: value => dispatch(toggleRefererPage(value)),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  getModulesForProgram: () => dispatch(modulesListRequest()),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  dropdownsRequest: () => dispatch(dropdownsRequest()),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  authHOC,
  lifecycle({
    componentWillMount() {
      const {
        loginReducer,
        getClientBackGroundRequest,
        view,
        savedVersions,
        toggleSaveEditPopup,
        toggleRefererPage,
        userProgramsFull,
        getAllThinkToolsAndJournals
      } = this.props;

     
      
     this.props.getModulesForProgram()

    },
    componentWillReceiveProps(nextProps) {
      const { loginReducer, getClientBackGroundRequest, view, userProgramsFull } = nextProps;
      
    },
  }),
 
)(Modules);

Modules.propTypes = {
  view: PropTypes.instanceOf(Object),
};
